/* eslint-disable quotes */
import * as yup from "yup"

export const regex = {
  singleName: /^[a-zA-Zא-ת\s'-]*$/,
  phoneNumber: /^05\d([-]{0,1})\d{7}$/,
  allPhoneNumber: /^(?:\+972-?|0)(?:5\d|[2-9]|7\d)(?:-)?\d{7}$/,
  IDCompanyId: /^(?:[0-9]{5,9}|51\d{7})$/,
  linkedin: /^https:\/\/www\.linkedin\.com\/in\//,
  // eslint-disable-next-line max-len, no-useless-escape
  url: /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
}

export const invalid = {
  firstName: "יש להקליד אותיות בעברית או באנגלית בלבד וללא סימנים מיוחדים",
  lastName: "ש להקליד אותיות בעברית או באנגלית בלבד וללא סימנים מיוחדים",
  phoneNumber: "מספר נייד לא תקין",
  email: "כתובת האימייל אינה תקינה",
  allPhoneNumber: "מספר טלפון לא תקין",
  description: "כאן צריך לכתוב בקצרה מדוע החלטת לשלוח פנייה",
  ID: 'מספר ת"ז/ח"פ לא תקין',
  linkedin: "הקישור אינו תקינה",
  subject: "subject error",
}

export const schemaCommon = {
  firstName: yup
    .string()
    .matches(regex.singleName, invalid.firstName)
    .max(25, invalid.firstName)
    .required("אנחנו צריכים לדעת מה השם שלך"),
  lastName: yup
    .string()
    .matches(regex.singleName, invalid.lastName)
    .max(25, invalid.lastName)
    .required("צריך למלא גם שם משפחה"),
  fullName: yup
    .string()
    .matches(regex.singleName, invalid.firstName)
    .max(50, invalid.firstName)
    .required("אנחנו צריכים לדעת מה השם שלך"),
  ID: yup.string().matches(regex.IDCompanyId, invalid.ID).required('אנא הקלד ת"ז/ח"פ'),
  phoneNumber: yup
    .string()
    .matches(regex.phoneNumber, invalid.phoneNumber)
    .length(10, invalid.phoneNumber)
    .required("מה מספר הנייד שלך? צריך למלא, כדי שנחזור אליך")
    .max(10, invalid.phoneNumber),
  city: yup.string().required("צריך לנסות להקליד את שם העיר שוב"),
  email: yup
    .string()
    .email(invalid.email)
    .required("אנחנו צריכים לקבל את כתובת האימייל שלך")
    .max(132, invalid.email),
  allPhoneNumber: yup
    .string()
    .matches(regex.allPhoneNumber, invalid.allPhoneNumber)
    .required("מה המספר שלך? צריך למלא, כדי שנחזור אליך")
    .max(10, invalid.allPhoneNumber),
  description: yup.string().required(invalid.description).max(500, invalid.description),
  comments: yup.string().nullable().notRequired(),
  subject: yup.string().min(1).required(),
  file: yup.string().required("required"),
  fileName: yup.string().required("required"),
  linkedin: yup.string().matches(regex.linkedin, invalid.linkedin),
  subscrube: yup.boolean().required(),
  jobId: yup.string().required(),
}

export const invalidDAF = {
  PartAAssociationDetailsName: "שם העמותה אינו תקין",
  PartAAssociationDetailsNumber: "מספר רשום אינו תקין",
  PartAAssociationDetailsPhone: "מספר טלפון אינו תקין",
  PartAAssociationDetailsWebsite: "אתר אינטרנט אינו תקין",
  PartAAssociationDetailsCeo: "פרטי מנכ״ל העמותה אינו תקין",
  PartAAmount: "הזנת סכום אינו תקין",
  PartAVolunteeringOptions: "תיאור הכישורים והמיומנויות הנדרשות אינו תקין",
  PartAContactUsDetailsName: "שם איש קשר אינו תקין",
  PartAContactUsDetailsContactRole: "תפקיד איש קשר אינו תקין",
  PartAContactUsDetailsPhone: "טלפון ליצירת קשר אינו תקין",
  PartAContactUsDetailsEmail: "כתובת למשלוח דוא״ל אינו תקין",
  PartAActivityAndGoals: "תיאור תמציתי אודות תחום פעילות העמותה ומטרותיה אינו תקין",
  PartAAshtromGroupConnection: "פרטו את הזיקה ומהות הקשר אינו תקין",

  PartBDescription: "תיאור כללי אינו תקין",
  PartBProjectGoals: "פירוט את מטרותיו העיקריות של הפרויקט אינו תקין",
  PartBTargetAudienceName: "קהל היעד אליו מיועד הפרויקט תקין",
  PartBTargetAudienceSupportingPeopleAmount: "כמות האנשים שצפויים לתמוך אינו תקין",
  PartBArea: "אזור הקשר אינו תקין",
  PartBProjectSchedule: "לוח נהזמנים ואבני דרך העיקריות אינו תקין",
  PartBChangesToAchieve: "פירוט מה הן תוצאות/השינויים אינו תקין",
  PartBProjectSuccessYourOpinion: "פירוט מה בעינייך הצלחת הפעילות אינו תקין",
}

export const schemaDonationRequest = {
  stringValue: yup.string().min(1).max(50).required(),
  stringValueTextarea: yup.string().min(1).max(500).required(),
  booleanValue: yup.string().max(50).required(),
  allPhoneNumber: yup.string().matches(regex.allPhoneNumber).required().max(10),
  email: yup.string().email().required().max(132),
  registeredNumber: yup
    .string()
    .matches(/^[0-9]+$/)
    .min(9)
    .max(9)
    .required(),
  urlValue: yup.string().matches(regex.url).required(),
  donationAmountValue: yup
    .string()
    .matches(/^[0-9]+$/)
    .min(1)
    .max(8)
    .required(),
  amountOfPeople: yup
    .string()
    .matches(/^[0-9]+$/)
    .min(1)
    .max(10)
    .required(),
  numberValue: yup
    .string()
    .matches(/^[0-9]+$/)
    .required(),
}
